import { useContext, useEffect, useState } from 'react';
import { EstateType, ServicesTitles } from '../../Enums';
import { FilterContext } from '../../filterTools';
import { makeCamelCase } from '../../helpers';
import { getCountyTag, getMunicipalityTag } from '../../services/api';

interface Props {
  path: Record<string, string>;
}

const SEOHeadingComponent = ({ path }: Props): JSX.Element => {
  const filterContext = useContext(FilterContext);
  const [currentPathEstateType, setCurrentPathEstateType] = useState(
    path.estateType !== 'bostad' && path.estateType
  );
  const [currentPathCounty, setCurrentPathCounty] = useState<string>();
  const initUrl = window.location.href;
  const [onHold, setOnHold] = useState<boolean>(false);
  const [currentPathMuni, setCurrentPathMuni] = useState<string>();
  const [headingToSend, setHeadingToSend] =
    useState<string>('Bostäder till salu');
  const [preambleToSend] = useState<string>('Boende med mindre klimatavtryck');

  useEffect(() => {
    if (
      path.estateType &&
      path.estateType !== 'bostad' &&
      path.estateType !== 'bra-energiklass'
    ) {
      let estateTypeCameled = '';
      estateTypeCameled = makeCamelCase(path.estateType);
      const inPlural =
        estateTypeCameled === EstateType.House
          ? 'Villor'
          : estateTypeCameled === EstateType.Cooperative ||
            estateTypeCameled === 'Bostadsratt'
          ? 'Bostadsrätter'
          : estateTypeCameled === EstateType.Cottage
          ? estateTypeCameled
          : estateTypeCameled === EstateType.Agriculture ||
            estateTypeCameled === 'Gard'
          ? 'Gårdar'
          : estateTypeCameled === EstateType.Commercial
          ? 'Kommersiellt'
          : estateTypeCameled === EstateType.Plot
          ? 'Tomter'
          : estateTypeCameled === EstateType.Project
          ? 'Nyproduktion'
          : '';
      if (inPlural !== currentPathEstateType) {
        setCurrentPathEstateType(inPlural);
      }
    } else if (path.estateType === 'bostad') {
      setCurrentPathEstateType('Bostäder');
    }
    async function createGeoHeading() {
      if (path.muni) {
        const rewrittenMunicip = makeCamelCase(
          await getMunicipalityTag(path.muni)
        );
        setCurrentPathMuni(rewrittenMunicip?.replace('(kommun)', ''));
      } else if (path.county) {
        const rewrittenCounty = makeCamelCase(await getCountyTag(path.county));
        setCurrentPathCounty(rewrittenCounty);
      } else {
        setCurrentPathCounty('');
      }
    }
    createGeoHeading();
    setOnHold(true);
  }, [filterContext.tags]);

  useEffect(() => {
    let headingToSendOutside = 'Bostäder till salu';
    if (
      initUrl.includes(path.estateType) &&
      !initUrl.includes('bra-energiklass') &&
      onHold
    ) {
      headingToSendOutside = currentPathEstateType + ' till salu ';
      if (currentPathMuni) {
        headingToSendOutside = headingToSendOutside + 'i ' + currentPathMuni;
      } else if (currentPathCounty) {
        headingToSendOutside = headingToSendOutside + 'i ' + currentPathCounty;
      }
    } else if (onHold && initUrl.includes('bra-energiklass')) {
      headingToSendOutside = ServicesTitles.GreenEstate;
    }
    setHeadingToSend(headingToSendOutside);
  }, [currentPathCounty, currentPathEstateType, currentPathMuni, initUrl]);

  (() => {
    const headingElem = document.getElementById('forSaleHeading');
    headingElem && initUrl.includes(path.estateType) && headingToSend
      ? (headingElem.innerHTML = headingToSend)
      : headingElem && (headingElem.innerHTML = 'Bostäder till salu');
  })();
  (() => {
    const preambleElem = document.getElementById('forSaleSeoPreamble');

    preambleElem && initUrl.includes('bra-energiklass') && preambleToSend
      ? (preambleElem.innerHTML = preambleToSend)
      : preambleElem && (preambleElem.innerHTML = '');
  })();

  return;
};
export default SEOHeadingComponent;
